/*
 * addon-bundle.js
 * Keeps every [data-fk-bundle] element in sync with the live cart.
 *
 * Rule: once the cart holds N or more items (N = data-fk-bundle-min), the add-on
 * bundle discount applies. Mirrors the "ADD-ON BUNDLE - 10% OFF" automatic
 * discount in Shopify Admin > Discounts.
 *
 * Loaded by snippets/addon-bundle-offer.liquid (defer-safe, self-guarding).
 */
(function () {
  'use strict';

  if (window.__fkAddonBundleLoaded) return;
  window.__fkAddonBundleLoaded = true;

  var lastCount = null;
  var pending = null;

  function bars() {
    return document.querySelectorAll('[data-fk-bundle]');
  }

  function render(bar, count) {
    var min = parseInt(bar.getAttribute('data-fk-bundle-min'), 10) || 2;
    var percent = parseInt(bar.getAttribute('data-fk-bundle-percent'), 10) || 10;
    var ctx = bar.getAttribute('data-fk-bundle-context') || 'cart';
    var badge = bar.querySelector('[data-fk-bundle-badge]');
    var text = bar.querySelector('[data-fk-bundle-text]');
    var unlocked = count >= min;

    bar.classList.toggle('is-unlocked', unlocked);

    if (unlocked) {
      if (badge) badge.textContent = 'UNLOCKED';
      if (text) text.innerHTML = '<strong>' + percent + '% off</strong> applied at checkout';
      return;
    }

    if (badge) badge.textContent = badge.getAttribute('data-locked-label') || 'BUNDLE & SAVE';

    if (!text) return;

    if (ctx === 'product') {
      text.innerHTML = 'Add any add-on and take <strong>' + percent + '% off</strong> your order';
    } else {
      var remaining = Math.max(min - count, 0);
      var word = remaining === 1 ? 'item' : 'items';
      text.innerHTML =
        'Add <strong>' + remaining + ' more ' + word + '</strong> to save <strong>' + percent + '%</strong>';
    }
  }

  function apply(count) {
    lastCount = count;
    Array.prototype.forEach.call(bars(), function (bar) {
      render(bar, count);
    });
  }

  function refresh() {
    if (!bars().length) return Promise.resolve();
    if (pending) return pending;
    pending = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        apply(cart.item_count || 0);
      })
      .catch(function () {
        /* leave the Liquid-rendered state in place */
      })
      .then(function () {
        pending = null;
      });
    return pending;
  }

  // Re-render immediately when new bars enter the DOM (cart drawer is replaced wholesale).
  function paintNewBars() {
    if (lastCount === null) {
      refresh();
      return;
    }
    Array.prototype.forEach.call(bars(), function (bar) {
      if (bar.dataset.fkPainted === String(lastCount)) return;
      bar.dataset.fkPainted = String(lastCount);
      render(bar, lastCount);
    });
  }

  var CART_EVENTS = [
    'cart:refresh',
    'cart:updated',
    'cart-drawer:updated',
    'cart:change',
    'ss:addon-added'
  ];

  function bind() {
    CART_EVENTS.forEach(function (name) {
      document.addEventListener(name, function () {
        setTimeout(refresh, 60);
      });
      document.documentElement.addEventListener(name, function () {
        setTimeout(refresh, 60);
      });
    });

    // Catch cart mutations made by any script on the page (theme, add-ons, bundle builder).
    if (window.fetch) {
      var nativeFetch = window.fetch;
      window.fetch = function () {
        var url = arguments[0];
        var href = typeof url === 'string' ? url : url && url.url ? url.url : '';
        return nativeFetch.apply(this, arguments).then(function (res) {
          if (/\/cart\/(add|change|update|clear)/.test(href)) {
            setTimeout(refresh, 60);
          }
          return res;
        });
      };
    }

    if (typeof MutationObserver !== 'undefined') {
      var debounce;
      var obs = new MutationObserver(function () {
        clearTimeout(debounce);
        debounce = setTimeout(paintNewBars, 80);
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  }

  function init() {
    bind();
    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.FractureAddonBundle = { refresh: refresh };
})();